module.exports = __webpack_public_path__ + "static/img/icon-wx-login.d42c2e6f.png";